import { INewProduct } from "../../Utils/types";
import { shopApi } from "../api";
import { ThunkAction } from "redux-thunk";
import { AppState, AppActions } from "../Store/store";

interface INewProductState {
  newProduct: INewProduct,
  uploadPhoto: string,
}
const newProductState: INewProductState = {
  newProduct: {
    id: 0,
    name: '',
    categoryId: 0,
    tags: [],
    price: 0,
    quantity: 0
  },
  uploadPhoto: '',
}

// Action types
export const SET_NEW_PRODUCT = 'new/SET_NEW_PRODUCT';
export const APPLY_NEW_PRODUCT = 'new/APPLY_NEW_PRODUCT';
export const UPLOAD_PHOTO = 'new/UPLOAD_PHOTO';

// Selectors
export const newProductSelector = (state: any) => state.new.newProduct;
export const photoSelector = (state: any) => state.new.uploadPhoto;

// Reducer
export function newProductReducer(state: INewProductState = newProductState, action: any) {
  switch (action.type) {
    case UPLOAD_PHOTO: {
      return {
        ...state,
        uploadPhoto: action.payload
      }
    }

    case SET_NEW_PRODUCT: {
      return {
        ...state,
        newProduct: {
          ...state.newProduct,
          [action.name]: action.payload
        }
      }
    }

    case APPLY_NEW_PRODUCT: {
      return {
        ...state,
        newProduct: {
          ...state.newProduct,
          id: action.payload
        }
      }
    }

    default: {
      return state;
    }
  }
}

// Actions
interface NewProductValuesType {
  type: typeof SET_NEW_PRODUCT,
  name: string,
  payload: any
}
export function newProductValues(name: string, payload: any): NewProductValuesType {
  return {
    type: SET_NEW_PRODUCT,
    name,
    payload
  };
}

interface UploadPhotoType {
  type: typeof UPLOAD_PHOTO,
  payload: any
}
export function uploadPhoto(file: any, id: number): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch: any, getState: any) => {
    const response = await shopApi.uploadPhoto(file, id);
    dispatch({
      type: UPLOAD_PHOTO,
      payload: response.photo
    });
  }
}

interface ApplyNewProductType {
  type: typeof APPLY_NEW_PRODUCT,
  payload: number
}
export function applyNewProduct(): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch: any, getState: any) => {
    const data = getState().new.newProduct;
    const response = await shopApi.newProduct(data);
    dispatch({
      type: APPLY_NEW_PRODUCT,
      payload: response.id
    });
  }
}

export type NewProductActions =
  ApplyNewProductType
  | UploadPhotoType
  | NewProductValuesType;